import { render, staticRenderFns } from "./OverlayLoader.vue?vue&type=template&id=331aca6a&scoped=true"
import script from "./OverlayLoader.vue?vue&type=script&lang=js"
export * from "./OverlayLoader.vue?vue&type=script&lang=js"
import style0 from "./OverlayLoader.vue?vue&type=style&index=0&id=331aca6a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331aca6a",
  null
  
)

export default component.exports